var randomString = function () {
    return Math.random()
        .toString(36)
        .substring(7)
        .split('')
        .join('.');
};
var ActionTypes = {
    SET_STATE: "@@icestore_SET_STATE".concat(/* #__PURE__ */ randomString()),
};
export default ActionTypes;
